export default __webpack_public_path__ + "static/media/ashoka-changemaker-logo.c308e177.png";